import React, { Component } from "react";
import styled from "styled-components";
import DataExplorer from "@nteract/data-explorer";
import { fetchMobileStatusExplorer } from "../api/dashStats"

class MobileStatusExplorer extends Component{
  state = {
    data: null,
    searchBy: "dd" // 'week' or 'dd'
  }
  async componentDidMount(){
    const token = localStorage.getItem("CWB_TOKEN");
    if(token){
      await this.fetchMobileStatus();
    }
  }
  fetchMobileStatus = async () => {
    try {
      const { searchBy } = this.state;
      const res = await fetchMobileStatusExplorer(searchBy);
      if(res.status === 200){
        this.setState({
          data:res.data.result
        })
      }
    }catch(err){
      console.log(err);
    }
  }
  handleChangeTimeFrame = async () => {
    this.setState(
      prev => ({ searchBy: prev.searchBy === "dd" ? "week" : "dd" }),
      this.fetchMobileStatus
    );
  }
  render(){
    const { data, searchBy } = this.state;
    const currentDateLabel = searchBy === "dd" ? "Daily" : "Weekly";
    const inverseDateLabel = searchBy === "dd" ? "Weekly" : "Daily";
    if (!data){
      return <Container>Loading..</Container>
    }
    return <Container>
      <h1>
      Sign-ups - Web vs Mobile 
      </h1>
      <div>
        <label>Current Time Frame:</label>&nbsp;
        <span style={{ fontSize: "1.2rem" }}>{currentDateLabel}</span> &nbsp;
        <button onClick={this.handleChangeTimeFrame}>Change to {inverseDateLabel}</button>
      </div>
      <br />
      {
       <DataExplorer data={data} />
      }
    </Container>
  }
}
const Container = styled.div`
  width: 80%;
  margin:24px auto;
  .iReLkr .ReactTable * {
    text-align:left
  }
`;


export default MobileStatusExplorer;